import { render, staticRenderFns } from "./MtsTakipAcView.vue?vue&type=template&id=52388ca4"
import script from "./MtsTakipAcView.vue?vue&type=script&lang=ts"
export * from "./MtsTakipAcView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports